import React from 'react';

import {PlaceholderWrapperComponent} from "../../../../core/components/placeholder/placeholder-wrapper";

export const GamesPredictionsWidgetGamePlaceholder = (props) => {
  return (
    <PlaceholderWrapperComponent className={'games-predictions-widget-game-placeholder-container'}>
      <div className={'games-predictions-widget-game-placeholder-content'}>
        <div className={'games-predictions-widget-game-placeholder-competitor-name'}/>
        <div className={'games-predictions-widget-game-placeholder-competitor-logo'}/>
        <div className={'games-predictions-widget-game-placeholder-center-text'}/>
        <div className={'games-predictions-widget-game-placeholder-competitor-logo'}/>
        <div className={'games-predictions-widget-game-placeholder-competitor-name'}/>
      </div>
    </PlaceholderWrapperComponent>
  )
}
